import { render, staticRenderFns } from "./SuperDetails.vue?vue&type=template&id=3075f246&scoped=true"
import script from "./SuperDetails.vue?vue&type=script&lang=js"
export * from "./SuperDetails.vue?vue&type=script&lang=js"
import style0 from "./SuperDetails.vue?vue&type=style&index=0&id=3075f246&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3075f246",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3075f246')) {
      api.createRecord('3075f246', component.options)
    } else {
      api.reload('3075f246', component.options)
    }
    module.hot.accept("./SuperDetails.vue?vue&type=template&id=3075f246&scoped=true", function () {
      api.rerender('3075f246', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketingCampaign/components/SuperDetails.vue"
export default component.exports